export default {
  default: () => import("/usr/src/app/layouts/default.vue")
}